import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";

import axios from "axios";
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import phone from "../../assets/newP (3).png";
import hero from "../../assets/hero.svg";
import visa from "../../assets/visa.svg";
import Video from "../../assets/blackboxstocks-hero.mp4-vimeo-744619626-hls-fastly_skyfire_sep-1400.mp4";

import mastercard from "../../assets/mastercard.svg";
import SavingsIcon from "@mui/icons-material/Savings";
import perfect from "../../assets/perfect_money.svg";
import advcash from "../../assets/advcash.svg";
import smile from "../../assets/anim.png";
// import f2 from "../../assets/dignity-2.png"
// import f3 from "../../assets/dignity-3.png"
// import f4 from "../../assets/dignity-4.png"

import stockTrading from "../../assets/cryptos.jpg";
import futures from "../../assets/futures.jpg";
import oil from "../../assets/oilandgas.jpg";
import energy from "../../assets/energy.jpg";
import estate from "../../assets/real-estate.jpg";

import gold from "../../assets/gold.jpg";
import nature from "../../assets/natural-cover.jpg";
import retire from "../../assets/retirement-income.jpg";
import forex from "../../assets/forex.jpg";
import winnnerbg from "../../assets/img-single1.jpg";
import professional from "../../assets/professionals.jpg";
import community from "../../assets/pexels-karolina-grabowska-7876672.jpg";
import co from "../../assets/ce8414d-23b1-0a0b-f232-16e64081f4d8_Investing-Apps.png";

import socialBg from "../../assets/social-bg.jpg";
import "./home.scss";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TradingViewWidget from "./Banner";
import HotlistsTradingViewWidget from "../../components/hotlist/HotlistsTradingViewWidget ";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import MoneySharpIcon from "@mui/icons-material/MoneySharp";
import MonetizationOnSharpIcon from "@mui/icons-material/MonetizationOnSharp";
import StackedLineChartSharpIcon from "@mui/icons-material/StackedLineChartSharp";
import ContactEmergencySharpIcon from "@mui/icons-material/ContactEmergencySharp";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import AlternateEmailSharpIcon from '@mui/icons-material/AlternateEmailSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import LocalPhoneSharpIcon from '@mui/icons-material/LocalPhoneSharp';
import { makeRequest } from "../../axios";

const Home = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const [tab, setSelectedTab] = useState("standard");
  const [formData, setFormData] = useState({
    name1: "",
    phone1: "",
    subject1: "",
    message1: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    try {
      await makeRequest.post("auth/contact", formData);
    } catch (err) {
      console.log(err);
    }

    console.log(formData);
    setFormData({
      name1: "",
      phone1: "",
      subject1: "",
      message1: "Message sent",
    });
  };
  const url =
    "https://finnhub.io/api/v1/news?category=general&token=cchg08qad3i4bkk56120";
  const [news, setNews] = useState([]);
  const [noOfNews, setNoOfNews] = useState(4);
  const slice = news.slice(0, noOfNews);

  useEffect(() => {
    axios
      .get(url)
      .then((res) => {
        setNews(res.data);
      })
      .then((err) => {
        console.log(err);
      });
  }, []);

 
  const [weekly, setWeekly] = useState(true)  
  const wikly = ()=>{
    setWeekly(true)
    console.log(weekly)
  }
  const wikly2 = ()=> {
    setWeekly(false)
  }


 
  return (
    <div className="home">
      <div className="banner">
        <div className="video-overlay">
          <video autoPlay muted loop className="background-video">
            <source src={Video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <Carousel activeIndex={index} onSelect={handleSelect}>
          <Carousel.Item>
            <div className="sec">
              <span className="head">Providing quality financial services</span>
              <span className="content">
                Advanced trading approach leverages sophisticated strategies,
                state-of-the-art tools, and in-depth market knowledge to enhance
                decision making, manage risk, and boost potential returns
              </span>
              <div className="btn-div flex">
                <Link to="/register">
                  <button className="reg-btn">Registration</button>
                </Link>
                <Link to="/register">
                  <button className="demo-btn">Open demo account</button>
                </Link>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="sec">
              <span className="head">Fully independent</span>
              <span className="content">
                Equitradezone is the easiest way to access smarter investment
                options and earn real returns. We make investing simple,
                accessible and affordable.
              </span>
              <div className="btn-div flex">
                <Link to="/about-us">
                  <button className="demo-btn"> 
                  Learn more
                  </button>
                </Link>
              </div>
            </div>

            {/* <img alt="" className="carousel-img" src={CarouselImage3} /> */}
          </Carousel.Item>
        </Carousel>
      </div>


      <div className="container" style={{ marginTop: "60px" }}>
        <div className="row">
          <div className="col-md-6">
            <div>
              <h3 className="myh3">WE HAVE A WIDE BREADTH OF EXPERIENCE</h3>
            </div>
            <div>
              <p className="myh4" style={{ fontWeight: "300" }}>
                The breadth of knowledge and experience at Equitradezone
                assures our clients that we have the skills necessary to focus
                on their important financial matters.
              </p>
            </div>
            <div></div>
            <div style={{ marginBottom: "20px" }}>
              <div className="btn-about" style={{ marginTop: "30px" }}>
                <a
                  href="certificate.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="themesflat-button"
                  style={{ borderRadius: "8px" }}
                >
                  Certificate Of Incorporation <ReceiptLongIcon />
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="bold-border">
              <img className="pro-img" src={professional} alt="Professionals" />
            </div>
          </div>
        </div>
      </div>

      <div className="second">
        {/* <div className="flex space logos">
          <img className="brand-logos" src={visa} alt="" />
          <img className="brand-logos" src={mastercard} alt="" />
          <img className="brand-logos" src={advcash} alt="" />
          <img className="brand-logos" src={perfect} alt="" />
        </div> */}

        <div className="cap">
          <div className="features-1 col">
            <div className="col f-fcol">
              <div className="col f-col">
                <span className="f-header">Our Financing Capabilities</span>
                <span className="f-content">
                  Impressive flexibility, speed of execution, and a broad range
                  of financing capabilities allow us to stand ready to partner
                  with our clients to meet their particular needs and, in most
                  cases, exceed their expectations.
                </span>
              </div>
            </div>
            <div
              className="col f-fcol"
              style={{ backgroundImage: `url(${socialBg})` }}
            >
              <div className="col f-col">
                <span className="f-header">Our Services</span>
                <span className="f-content">
                  Equitradezone provides innovative capital solutions to meet
                  the challenges of a rapidly evolving financial environment
                  efficiently. Let us show you how we differ from the rest of
                  the financial community. We know the future of your company
                  could depend on the options we provide you with today. We work
                  nationally to serve all of your financing needs with an
                  ability to deliver global financing wherever the US can
                  legally provide business assistance.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="products" style={{ marginTop: "-100px" }}>
          <h2>BEST SERVICES OFFER</h2>
          <hr
            style={{
              width: "84px",
              height: "5px",
              backgroundColor: "#77C25A",
              color: "#77C25A",
              marginTop: "-30px",
            }}
          />
          <p>
            Appropriate and sufficient financing for a company is crucially
            important for its long-term success. We advise you in choosing the
            appropriate type of financing
          </p>
          <div className="product-flex">
            <div className="product-box">
              <div style={{ background: "#EEEAE2" }}>
                <img src={stockTrading} className="product-img" alt="" />
              </div>
              <div className="bottom">
                <span className="heading">CRYPTOCURRENCY INVESTMENTS</span>
                <span className="cnt">
                  Crypto trading is a unique platform for trading
                  cryptocurrencies against each other
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">
                  Learn more</button>
                  </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={futures} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">STOCKS TRADING & INVESTMENTS</span>
                <span className="cnt">
                  The foreign exchange market is a global decentralized or
                  over-the-counter market for the trading of currencies.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={estate} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">REAL ESTATE INVESTMENTS</span>
                <span className="cnt">
                  We offers investment options for multi-family, business,
                  retail and hospitality properties in most major cities
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="product-flex">
            <div className="product-box">
              <img src={energy} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">ENERGY AND POWER INVESTMENTS</span>
                <span className="cnt">
                  We do the best to involve in world's energy and power
                  production and distribution.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={gold} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">GOLD INVESTMENTS</span>
                <span className="cnt">
                  Investors generally buy gold as a form of risk
                  diversification.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={nature} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">NATURAL RESOURCES INVESTMENTS</span>
                <span className="cnt">
                  Natural resource investing covers anything mined or collected
                  in raw form.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="product-flex">
            <div className="product-box">
              <img src={oil} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">OIL AND GAS INVESTMENTS</span>
                <span className="cnt">
                  Oil is making the world go round, and then there is no
                  indication that this will change.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={retire} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">RETIREMENT INCOME</span>
                <span className="cnt">
                  We help you earn from forex in the best possible way. We make
                  your money work for you.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
            <div className="product-box">
              <img src={forex} className="product-img" alt="" />
              <div className="bottom">
                <span className="heading">FOREX AND OPTIONS TRADING</span>
                <span className="cnt">
                  We help you earn from forex in the best possible way. We make
                  your money work for you.
                </span>
                <Link to="/about-us">
                <button className="learn-more-btn">Learn more</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: "50px 100px", textAlign: "center" }}>
          <h1 style={{ color: "#fff" }}>
            Everything You Expect From A Trading Expert
          </h1>
          <hr style={{ marginTop: "40px", color: "#fff" }} />

          <div style={{ display: "flex", gap: "20px" }}>
            <div className="trading-f">
              <span className="heading">Robust Oversight</span>
              <span className="cnt">
                Portfolio risk management is supplemented by our independent
                risk and quantitative analytics team-which partners with
                investment teams to measure behavioral biases and other risks
                but reports to senior investment management-and an operational
                risk management function that assesses risk across the complex.
              </span>
            </div>
            <div className="trading-f">
              <span className="heading">Clear Investment Processes</span>
              <span className="cnt">
                Our transparent investment processes detail how each investment
                team identifies and implements investment opportunities and the
                risk/return profile to be expected. We believe that strict
                adherence to these guidelines is one of the most effective forms
                of risk management.
              </span>
            </div>
            <div className="trading-f">
              <span className="heading">ESG Integration</span>
              <span className="cnt">
                As a signatory of the United Nations-supported Principles for
                Responsible Investment (UN PRI) initiative, we're committed to
                investing responsibly and supported by a global team of
                dedicated ESG specialists whose recommendations help shape the
                investment process.
              </span>
            </div>
          </div>
        </div>

        <div className="step-trading">
          <div className="col first">
            <div>
              <h3 className="myh3" style={{ color: "#6ed25a" }}>
                Trading Community
              </h3>
            </div>
            <div>
              <p style={{ color: "#fff" }}>
                No one trades alone. Chat directly with experienced and new
                traders alike on the Equitradezone platform. There's no need
                to waste precious time switching between platforms and tabs.
              </p>
            </div>
            <ul>
              <li>Listen to Live Channels</li>
              <li>Collaborate and Share Ideas</li>
              <li>Interact with Seasoned Veterans in a Team Environment</li>
            </ul>

            <div className="col first-div2">
              <Link to="/register" >
              <button className="reg-btnnn">Open live account</button>
              </Link>
            </div>
          </div>
          <div style={{ backgroundImage: `url(${community})` }} className="sec"></div>
        </div>

        <div className="t-vi-widget" >
          <TradingViewWidget />
        </div>

        <div className="n-c-div">
          <div className="news-items col">
            <span className="n-c-head">Top news</span>

            <div className="news-item-div col">
              {slice.map((item, i) => (
                <Link className="news-item">
                  <img className="news-img" src={item.image} alt="" />
                  <div className="n-flex col">
                    <span className="news-headline">{item.headline}</span>
                    {/* <span className='news-source' >source: {item.source}</span> */}
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="chart">
            <HotlistsTradingViewWidget />
          </div>
        </div>

        <div className="">
          <div className="top products">
            <h2>OUR ANALYSIS COVERS</h2>
            <p>
              We have knowledgeable practitioners including a Certified
              Financial Planner, a Certified Investment Management Analyst, an
              attorney, and a tax practitioner.
            </p>

            <hr
              style={{
                width: "84px",
                height: "5px",
                backgroundColor: "#77C25A",
                color: "#77C25A",
                marginTop: "-10px",
              }}
            />
          </div>
          <div className="features" style={{ marginTop: "-20px" }}>
            <div className="features-1 col">
              <div className="col f-fcol">
                <div className="col f-col">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <span className="f-header">
                      INVESTMENT MANAGEMENT{" "}
                      <SavingsIcon style={{ color: "#77C25A" }} />{" "}
                    </span>
                    <span className="f-content">
                      Investment management is not just restricted to buying and
                      selling assets, it also includes handling financial assets
                      and other investments.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col f-fcol">
                <div className="col f-col">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <span className="f-header">
                      INSURANCE CONSULTING{" "}
                      <MoneySharpIcon style={{ color: "#77C25A" }} />
                    </span>
                    <span className="f-content">
                      With our insurance consulting services, we help insurers
                      drive operational efficiency, improve customer service,
                      and increase profitability.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="features-1 col">
              <div className="col f-fcol">
                <div className="col f-col">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <span className="f-header">
                      FINANCIAL CONSULTING{" "}
                      <AssuredWorkloadIcon style={{ color: "#77C25A" }} />
                    </span>
                    <span className="f-content">
                      We work with our clients to better understand their assets
                      and what they want those assets to do for them now and in
                      the future.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col f-fcol">
                <div className="col f-col">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <span className="f-header">
                      TAXES PREPARATION{" "}
                      <MonetizationOnSharpIcon style={{ color: "#77C25A" }} />{" "}
                    </span>
                    <span className="f-content">
                      Preparing tax returns, often income tax returns, often for
                      a person other than the taxpayer, and generally for
                      compensation.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       

        <div class="wrapper"  >
        <fieldset style={{ color:"white"}}>
        <div>
            <label>
                <input type="radio" name="radio" onClick={wikly} checked/>
                <span>Standard</span>
            </label>
            {/* <label>
                <input type="radio" name="radio" onclick="selectPlan('monthly')"/>
                <span>Advanced</span>
            </label>
            <label>
                <input type="radio" name="radio" onclick="selectPlan('nfp')"/>
                <span>NFP</span>
            </label> */}
            <label>
                <input type="radio" name="radio" onClick={wikly2}/>
                <span>CHEMBERS</span>
            </label>
        </div>
    </fieldset><br/>
    <div class="price-tab weekly active animate__animated animate__fadeIn" style={weekly ? {display:"block"} : {display:"none"}}>
        <div class="pricing-table">
            <div class="pricing-box-2">
                <h2>TIER I PLAN </h2>
                <span class="price">30% - 35% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>minimum:$50,000</li>
                    <li>maximum:$100,000</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
            <div class="pricing-box-2">
                <h2>TIER II PLAN </h2>
                <span class="price">35% - 40% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>minimum:$150,000</li>
                    <li>maximum:$350,000</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
            <div class="pricing-box-2">
                <h2>TIER III PLAN </h2>
                <span class="price">40% - 45% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>minimum:$500,000</li>
                    <li>maximum:UNLIMITED</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
            
        </div>
    </div>



    <div class="price-tab btc"  style={weekly ? {display:"none"} : {diplay:"block"}}>
        <div class="pricing-table">

            <div class="pricing-box-2">
                <h2>PRO CHEMBERS</h2>
                <span class="price">90% - 95% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>30+ BTC</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>

            <div class="pricing-box-2">
                <h2>STANDARD CHEMBERS</h2>
                <span class="price">70% - 75% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>5 - 14.9 BTC</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
            <div class="pricing-box-2">
                <h2>PREMIUM CHEMBERS</h2>
                <span class="price">80% - 85% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>15 - 29.9 BTC</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
            <div class="pricing-box-2">
                <h2>BASIC CHEMBERS</h2>
                <span class="price">65% - 70% PIPS</span>
                
                <span class="pricing-table-divider"></span>
                <a class="btn" href="/register"><b>Get Started</b></a>
                <span class="pricing-table-divider"></span>
                <ul>
                    <li>1 - 1.5 BTC</li>
                    <li>10% Trade Commission</li>
                    <li>24/7 active support</li>
                </ul>
            </div>
        </div>
    </div>



   </div>




        <div className="features">
          <div className="features-1 col">
            <div className="col f-fcol">
              <div className="col f-col">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <span className="f-header">
                    Variety{" "}
                    <StackedLineChartSharpIcon style={{ color: "#77C25A" }} />{" "}
                  </span>
                  <span className="f-content">
                    Equitradezone. provides brokers a wide assortment of
                    financing programs at competitive rates to satisfy all their
                    clients' needs.
                  </span>
                </div>
              </div>
            </div>
            <div className="col f-fcol">
              <div className="col f-col">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <span className="f-header">
                    Service to You{" "}
                    <ContactEmergencySharpIcon style={{ color: "#77C25A" }} />{" "}
                  </span>
                  <span className="f-content">
                    We provide quick, accurate, and consistent service in
                    handling your clients' applications and getting the funds
                    into their hands.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="features-1 col">
            <div className="col f-fcol">
              <div className="col f-col">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <span className="f-header">
                    Service to Your Customers{" "}
                    <SupervisorAccountOutlinedIcon
                      style={{ color: "#77C25A" }}
                    />
                  </span>
                  <span className="f-content">
                    Your customer's opinion of your financing company reflects
                    upon you. Equitradezone. provides prompt, courteous,
                    professional, and available service throughout the life of
                    our financing partnership.
                  </span>
                </div>
              </div>
            </div>
            <div className="col f-fcol">
              <div className="col f-col">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <span className="f-header">
                    Flexibility{" "}
                    <ThumbUpAltOutlinedIcon style={{ color: "#77C25A" }} />{" "}
                  </span>
                  <span className="f-content">
                    The rules of conventional financing often fail to recognize
                    a reasonable credit risk. We look at the entire picture,
                    taking into account critical issues and project parameters.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="n-cont-div">
          <div className="news-items col">
            <span className="n-c-head" style={{ color: "#fff" }}>
              CONTACT FORM
            </span>
            <form onSubmit={handleSubmit} className="contact-form wpcf7-form">
              <span className="">
                <input
                  type="email"
                  id="name1"
                  name="name1"
                  value={formData.name1}
                  onChange={handleChange}
                  className="wpcf7-form-control"
                  placeholder="Enter Email*"
                  required
                  tabIndex="1"
                />
              </span>

              <span className="">
                <input
                  type="text"
                  id="phone1"
                  name="phone1"
                  value={formData.phone1}
                  onChange={handleChange}
                  className="wpcf7-form-control"
                  placeholder="Enter Phone*"
                  required
                  tabIndex="2"
                />
              </span>

              <span className="wpcf7-form-control-wrap your-subject">
                <input
                  type="text"
                  id="subject1"
                  name="subject1"
                  value={formData.subject1}
                  onChange={handleChange}
                  className="wpcf7-form-control"
                  placeholder="Enter Subject*"
                  required
                  tabIndex="3"
                />
              </span>

              <span className="">
                <textarea
                  name="message1"
                  id="message1"
                  value={formData.message1}
                  onChange={handleChange}
                  cols="40"
                  rows="5"
                  className="wpcf7-form-control wpcf7-textarea"
                  placeholder="Enter Message*"
                  required
                  tabIndex="4"
                  style={{ width: "80%" }}
                />
              </span>

              <div className="wrap-submit">
                <input
                  style={{ width: "30%", background: "#77C25A", color: "#fff" }}
                  type="submit"
                  value="SUBMIT"
                  className="submit wpcf7-form-control wpcf7-submit"
                  id="submit"
                  name="submit"
                />
              </div>


              
            </form>

          </div>


          <div className="chart">
            <img src={winnnerbg} alt="" />
          </div>
        </div>

        {/* <div>
          <div style={{display:"flex", justifyContent:"center", padding:".5rem"}}>
            <p style={{marginRight:"2rem", color:"green"}}><AlternateEmailSharpIcon/></p> <p style={{color:"white"}}>lol@gmail.com</p>
          </div>
          <div style={{display:"flex", justifyContent:"center", padding:".5rem"}}>
            <p style={{marginRight:"2rem", color:"green"}}><LocationOnSharpIcon/></p> <p style={{color:"white"}}>lol@gmail.com</p>
          </div>
          <div style={{display:"flex", justifyContent:"center", padding:".5rem"}}>
            <p style={{marginRight:"2rem", color:"green"}}><LocalPhoneSharpIcon/></p> <p style={{color:"white"}}>lol@gmail.com</p>
          </div>
          </div> */}



        <div className="pro-trading">
          <div style={{ backgroundImage: `url(${co})` }} className="sec"></div>
          <div className="col first">
            <div>
              <h2 className="h3s" style={{ color: "#fff" }}>
              Become a Pro Trader
              </h2>
            </div>
            <div className="box" >
               <span className="heading" >A reliable trading platform is the foundation of success </span>
               <span className="cont" >Every trader wants to profit in the best conditions and doesn't want to fear for the safety of personal funds. The first obvious thing a novice trader does is to study different online trading sites.</span>
               <span className="cont"  >The main criteria for a successful internet trading platform are international reputation, unwavering reliability, constant support at all stages, and unique useful trading features. These qualities are combined in the award-winning EquiTradezone broker and electronic trading platform.</span>
            </div>
            <div className="box" >
               <span className="heading" >Time to take action with the international EquiTradezone Trade trading broker </span>
               <span className="cont" >Trading will bring you profit with proper support, constant education, and a reasonable approach. EquiTradezone is a broker platform that has created all the conditions to help you improve your trading life in every possible way.</span>
            </div>

          </div>
        </div>
        <div>
          <div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
